import React from "react";
import { useNavigate } from "react-router-dom";
import { BsClock, BsThermometerHigh } from "react-icons/bs";

import { useDashboard } from '../context/DashboardContext';

export default function RecentIncidents() {
  const navigate = useNavigate();

  const { dashboardData, loading, errors } = useDashboard();
  const incidents = (dashboardData.recentIncidents || []).map(row => ({ ...row,
    typeColor: row.status === 'Closed' ? 'text-green-600' : 'text-amber-500',
    time: new Date(row.time).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }),
    icon: row.type === 'Equipment Failure' ? <BsThermometerHigh className="text-xl text-red-500" /> : <BsClock className="text-xl text-amber-500" />,
  }));

  const handleViewAll = () => {
    navigate("/incident");
  };

  const handleReportIncident = () => {
    navigate("/incident");
  };

  return (
    <div className="max-w-xl w-full bg-white border border-slate-100 rounded-3xl p-6 shadow-sm font-sans text-slate-800">
      {/* HEADER SECTION */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-slate-900">Recent Incidents</h2>

        <button
          type="button"
          onClick={handleViewAll}
          className="text-[#3a31d8] text-xs font-bold hover:underline"
        >
          View All
        </button>
      </div>

      {/* INCIDENTS LIST CONTAINER */}
      <div className="border border-slate-100 rounded-2xl bg-white px-5 divide-y divide-slate-100 mb-4">
        {!incidents.length && <p className="py-4 text-sm text-slate-400">{loading.recentIncidents ? 'Loading…' : errors.recentIncidents ? 'Unable to load incidents.' : 'No incidents recorded.'}</p>}
        {incidents.map((incident) => (
          <div
            key={incident.id}
            className="py-4 flex gap-4 items-start justify-between"
          >
            {/* Left Content Column */}
            <div className="flex gap-3.5 items-start">
              <div className="mt-0.5 shrink-0">{incident.icon}</div>

              <div>
                <span
                  className={`text-xs font-bold ${incident.typeColor} tracking-wide`}
                >
                  {incident.type}
                </span>

                <h3 className="text-sm font-bold text-slate-800 mt-1 leading-snug">
                  {incident.description}
                </h3>

                <p className="text-[11px] text-slate-400 font-medium mt-0.5">
                  Reported by: {incident.reporter}
                </p>
              </div>
            </div>

            {/* Right Status Column */}
            <div className="flex flex-col items-end gap-3 shrink-0">
              <span className="text-[11px] font-semibold text-slate-400">
                {incident.time}
              </span>

              <span className="bg-red-50 text-red-500 text-[11px] font-bold px-3 py-1 rounded-lg border border-red-100/50">
                {incident.status}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* BOTTOM ACTION BUTTON */}
      <button
        type="button"
        onClick={handleReportIncident}
        className="w-full bg-[#f4f3ff] hover:bg-[#e9e7ff] text-[#3a31d8] py-3 rounded-xl text-xs font-bold transition flex items-center justify-center gap-1.5 border border-transparent active:border-slate-200"
      >
        <span>Report New Incident</span>
      </button>
    </div>
  );
}
